import { TableCell, TableSortLabel } from '@mui/material';
import type { ReactNode } from 'react';

import type { SortStateType } from './useSort';

type SortableCellProps<TKey extends string> = {
  sort: SortStateType<TKey>;
  column: TKey;
  align?: 'left' | 'center' | 'right';
  children: ReactNode;
};

/**
 * A header cell that sorts — the only one. A hand-rolled `<TableSortLabel>` is how tables drift apart, and
 * `scripts/check-tables.sh` refuses it.
 */
export const SortableCell = <TKey extends string>({
  sort,
  column,
  align,
  children,
}: SortableCellProps<TKey>) => (
  <TableCell align={align} sortDirection={sort.key === column ? sort.direction : false}>
    <TableSortLabel
      active={sort.key === column}
      direction={sort.key === column ? sort.direction : 'asc'}
      onClick={() => sort.toggle(column)}
    >
      {children}
    </TableSortLabel>
  </TableCell>
);
